import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Modal from '../../shared/modals/modal.component';

import {
  fetchInitialDataForChartAccountModal,
  hideChartAccountModalForAddEdit,
  saveChartAccount,
} from './store/actions';
import {
  r2rAccountOptions,
  importStatusOptionsSelector,
  isFetchingInitialDataForAddAndEditChartAccountModalSelector,
} from './store/selectors';
import { ChartAccountPropTypes } from './propTypes';
import Form from '../../shared/forms/form.component';
import FormikProvider from '../../shared/forms/formikProvider.component';
import schema from './chartAccount.schema';
import { requiredWhenPresent } from '../../shared/propTypes';

const ModalTitles = {
  ADD: 'Add Chart Account',
  EDIT: 'Edit Chart Account',
};

class AddChartAccountModal extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    chartName: requiredWhenPresent(['isVisible'], PropTypes.shape({
      value: PropTypes.string.isRequired,
    })),

    openForEdit: PropTypes.bool,
    isSavingInProgress: PropTypes.bool.isRequired,

    hideModal: PropTypes.func.isRequired,
    saveEntity: PropTypes.func.isRequired,

    r2rAccountOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    importStatusOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number,
    })),

    entityToEdit: ChartAccountPropTypes,
    isVisible: PropTypes.bool,

    fetchInitialDataForChartAccountModal: PropTypes.func.isRequired,
    isFetchingInitialData: PropTypes.bool,

    localAccount: PropTypes.string,
  };

  state = {
    addAnother: false,
  };

  componentDidMount() {
    this.props.fetchInitialDataForChartAccountModal();
  }

  save = (chartAccountData, { setSubmitting, resetForm }) => {
    const { period, chartName, saveEntity, openForEdit } = this.props;
    const { addAnother } = this.state;

    this.setState({ addAnother: false }, () => {
      saveEntity({
        chartAccountData,
        chartName,
        period,
      }, openForEdit, { callback: resetForm, keepOpenAfterSaving: addAnother });
      setSubmitting(false);
    });
  };

  renderModal = ({ formik, schema }) => {
    const {
      openForEdit,
      hideModal,
      isVisible,
      isSavingInProgress,
      r2rAccountOptions,
      importStatusOptions,
      isFetchingInitialData,
    } = this.props;

    const submit = () => {
      this.setState({
        addAnother: false,
      }, () => formik.handleSubmit());
    };

    const submitAndAddAnotherAction = () => {
      this.setState({
        addAnother: true,
      }, () => formik.handleSubmit());
    };

    const reset = () => {
      hideModal();
      formik.resetForm();
    };

    return (
      <Modal
        className="add-chart-account-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset} // eslint-disable-line react/jsx-no-bind
        dismissText="Cancel"
        dismissAction={reset} // eslint-disable-line react/jsx-no-bind
        submitText="Save"
        submitAction={submit} // eslint-disable-line react/jsx-no-bind
        isSubmitting={formik.isSubmitting || isSavingInProgress}
        submitAndAddAnotherAction={!openForEdit ? submitAndAddAnotherAction : null}
        submitAndAddAnotherText="Save and Add Another"
        isVisible={isVisible}
        isLoading={isFetchingInitialData}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={{
            r2rAccountOptions,
            importStatusOptions,
            openForEdit,
          }}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit, openForEdit } = this.props;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.save}
        render={this.renderModal}
        validationContext={{ openForEdit }}
      />
    );
  }
}

function mapStateToProps(state) {
  const { administration } = state;
  return {
    r2rAccountOptions: r2rAccountOptions(state),
    importStatusOptions: importStatusOptionsSelector(state),
    isSavingInProgress: administration.chartOfAccounts.isSavingInProgress,
    isFetchingInitialData: isFetchingInitialDataForAddAndEditChartAccountModalSelector(state),
  };
}

export default connect(
  mapStateToProps,
  {
    fetchInitialDataForChartAccountModal,
    hideModal: hideChartAccountModalForAddEdit,
    saveEntity: saveChartAccount,
  }
)(AddChartAccountModal);
